export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtOPAVaria';
export const NAME = 'ZarazeniPredmetuPujcovny';
